var __decorate=this&&this.__decorate||function(e,t,i,o){var n,s=arguments.length,a=s<3?t:null===o?o=Object.getOwnPropertyDescriptor(t,i):o;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,i,o);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(a=(s<3?n(a):s>3?n(t,i,a):n(t,i))||a);return s>3&&a&&Object.defineProperty(t,i,a),a},__awaiter=this&&this.__awaiter||function(e,t,i,o){return new(i||(i=Promise))(function(n,s){function a(e){try{d(o.next(e))}catch(e){s(e)}}function l(e){try{d(o.throw(e))}catch(e){s(e)}}function d(e){var t;e.done?n(e.value):((t=e.value)instanceof i?t:new i(function(e){e(t)})).then(a,l)}d((o=o.apply(e,t||[])).next())})};import{css as e,html as t,unsafeCSS as i}from"lit";import{OrElement as o}from"@openremote/or-element";import{customElement as n,property as s,state as a}from"lit/decorators.js";import{classMap as l}from"lit/directives/class-map.js";import{ifDefined as d}from"lit/directives/if-defined.js";import{when as r}from"lit/directives/when.js";import{until as c}from"lit/directives/until.js";import{MDCTextField as p}from"@material/textfield";import{MDCRipple as h}from"@material/ripple";import{MDCCheckbox as u}from"@material/checkbox";import{MDCSwitch as m}from"@material/switch";import{MDCSlider as y}from"@material/slider";import{MDCSelect as v}from"@material/select";import{MDCList as _}from"@material/list";import{MDCFormField as b}from"@material/form-field";import{MDCIconButtonToggle as f}from"@material/icon-button";import{DefaultColor4 as T,DefaultColor5 as I,DefaultColor8 as g,Util as x}from"@openremote/core";import"@openremote/or-icon";import{getItemTemplate as O,getListTemplate as w,ListType as C}from"./or-mwc-list";import{i18next as $}from"@openremote/or-translate";let buttonStyle=require("@material/button/dist/mdc.button.css"),buttonFabStyle=require("@material/fab/dist/mdc.fab.css"),iconButtonStyle=require("@material/icon-button/dist/mdc.icon-button.css"),textfieldStyle=require("@material/textfield/dist/mdc.textfield.css"),rippleStyle=require("@material/ripple/dist/mdc.ripple.css"),lineRippleStyle=require("@material/line-ripple/dist/mdc.line-ripple.css"),floatingLabelStyle=require("@material/floating-label/dist/mdc.floating-label.css"),formFieldStyle=require("@material/form-field/dist/mdc.form-field.css"),checkboxStyle=require("@material/checkbox/dist/mdc.checkbox.css"),radioStyle=require("@material/radio/dist/mdc.radio.css"),switchStyle=require("@material/switch/dist/mdc.switch.css"),selectStyle=require("@material/select/dist/mdc.select.css"),listStyle=require("@material/list/dist/mdc.list.css"),menuSurfaceStyle=require("@material/menu-surface/dist/mdc.menu-surface.css"),menuStyle=require("@material/menu/dist/mdc.menu.css"),sliderStyle=require("@material/slider/dist/mdc.slider.css");export class OrInputChangedEvent extends CustomEvent{constructor(e,t,i){super(OrInputChangedEvent.NAME,{detail:{value:e,previousValue:t,enterPressed:i},bubbles:!0,composed:!0})}}OrInputChangedEvent.NAME="or-mwc-input-changed";export var InputType;function inputTypeSupportsButton(e){return e===InputType.NUMBER||e===InputType.BIG_INT||e===InputType.TELEPHONE||e===InputType.TEXT||e===InputType.PASSWORD||e===InputType.DATE||e===InputType.DATETIME||e===InputType.EMAIL||e===InputType.JSON||e===InputType.JSON_OBJECT||e===InputType.MONTH||e===InputType.TEXTAREA||e===InputType.TIME||e===InputType.URL||e===InputType.WEEK}function inputTypeSupportsHelperText(e){return inputTypeSupportsButton(e)||e===InputType.SELECT}function inputTypeSupportsLabel(e){return inputTypeSupportsHelperText(e)||e===InputType.CHECKBOX||e===InputType.BUTTON_MOMENTARY}!function(e){e.BUTTON="button",e.BUTTON_TOGGLE="button-toggle",e.BUTTON_MOMENTARY="button-momentary",e.CHECKBOX="checkbox",e.CHECKBOX_LIST="checkbox-list",e.COLOUR="color",e.DATE="date",e.DATETIME="datetime-local",e.EMAIL="email",e.JSON="json",e.JSON_OBJECT="json-object",e.MONTH="month",e.NUMBER="number",e.BIG_INT="big-int",e.PASSWORD="password",e.RADIO="radio",e.SWITCH="switch",e.RANGE="range",e.TELEPHONE="tel",e.TEXT="text",e.TEXTAREA="textarea",e.TIME="time",e.URL="url",e.WEEK="week",e.SELECT="select",e.LIST="list",e.CRON="cron",e.DURATION="duration",e.DURATION_TIME="duration-time",e.DURATION_PERIOD="duration-period"}(InputType||(InputType={}));export const SUPPORTED_WELLKNOWN_VALUE_TYPES=["text","email","UUID","assetID","hostOrIPAddress","IPAddress","boolean","bigNumber","number","positiveInteger","positiveNumber","long","integer","byte","integerByte","direction","TCP_IPPortNumber","bigInteger","colourRGB","dateAndTime","timestamp","timestampISO8601","CRONExpression","timeDurationISO8601","periodDurationISO8601","timeAndPeriodDurationISO8601","JSONObject"];let style=e`
  :host {
    display: inline-block;
    --internal-or-mwc-input-color: var(--or-mwc-input-color, var(--or-app-color4, ${i(T)}));
    --internal-or-mwc-input-text-color: var(
      --or-mwc-input-text-color,
      var(--or-app-color8, ${i(g)})
    );

    --mdc-theme-primary: var(--internal-or-mwc-input-color);
    --mdc-theme-on-primary: var(--internal-or-mwc-input-text-color);
    --mdc-theme-secondary: var(--internal-or-mwc-input-color);
  }

  :host([hidden]) {
    display: none;
  }

  :host([type="select"]) {
    height: 56px;
  }

  #wrapper {
    display: flex;
    align-items: center;
    min-height: 48px;
    height: 100%;
  }

  #wrapper > label {
    white-space: nowrap;
    margin-right: 20px;
  }

  #component {
    max-width: 100%;
  }

  .mdc-text-field {
    flex: 1 1 0;
  }

  .mdc-list {
    flex: 1;
    overflow: auto;
  }

  .mdc-select__anchor {
    max-width: 100%;
    width: 100%;
  }

  .mdc-checkbox-list input {
    display: none;
  }

  .mdc-checkbox-list label {
    display: block;
    border-radius: 50%;
    text-align: center;
    width: 32px;
    line-height: 32px;
    height: 32px;
    cursor: pointer;
    background-color: var(--or-app-color2);
    font-size: 13px;
  }

  input::-webkit-calendar-picker-indicator {
    margin: 0;
  }

  .mdc-checkbox-list .mdc-checkbox {
    padding: 0;
    height: 32px;
    width: 32px;
  }
  .mdc-radio-container {
    display: flex;
    flex-direction: column;
  }
  .mdc-form-field:has(> .mdc-radio) {
    height: 56px !important;
  }
  .mdc-text-field.mdc-text-field--invalid:not(.mdc-text-field--disabled)
    + .mdc-text-field-helper-line
    .mdc-text-field-helper-text {
    color: var(--mdc-theme-error, #b00020);
  }

  .mdc-checkbox-list input:checked + label {
    color: var(--or-app-color2);
    background-color: var(--mdc-theme-primary);
  }

  .mdc-button--rounded,
  .or-mwc-input--rounded {
    border-radius: 24px !important;
    --mdc-shape-small: 32px;
  }

  #select-searchable {
    background-color: transparent;
    border: 1px solid var(--or-app-color5, ${i(I)});
    margin: 8px;
    width: calc(100% - 16px);
    border-radius: 4px;
    padding: 4px 16px;
    flex: 0 0 auto;
    align-items: center;
    height: auto;
  }

  .mdc-text-field__input::-webkit-calendar-picker-indicator {
    display: block;
  }

  ::-webkit-clear-button {
    display: none;
  }
  ::-webkit-inner-spin-button {
    display: none;
  }
  ::-webkit-datetime-edit {
    padding: 0em;
  }
  ::-webkit-datetime-edit-text {
    padding: 0;
  }

  .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label {
    color: var(--mdc-theme-primary);
  }
  .mdc-text-field--focused .mdc-text-field__input:required ~ .mdc-floating-label::after,
  .mdc-text-field--focused .mdc-text-field__input:required ~ .mdc-notched-outline .mdc-floating-label::after {
    color: var(--mdc-theme-primary);
  }

  .mdc-text-field__input.resize-vertical {
    resize: vertical;
  }

  .mdc-text-field,
  .mdc-text-field-helper-line {
    width: 100%;
  }

  .mdc-text-field.dense-comfortable,
  .mdc-select.dense-comfortable {
    height: 48px;
  }

  .mdc-text-field.dense-compact {
    height: 36px;
  }

  .mdc-select:not(.mdc-list) {
    white-space: nowrap;
    display: flex;
    flex-direction: column;
  }

  .mdc-select:not(.mdc-select--disabled).mdc-select--focused .mdc-floating-label {
    color: var(--mdc-theme-primary);
  }

  .mdc-select-helper-text {
    white-space: normal;
    color: rgba(0, 0, 0, 0.6);
  }

  .mdc-icon-button {
    padding: 0;
    color: var(--internal-or-mwc-input-color);
  }

  /* Give slider min width like select etc. */
  .mdc-slider {
    min-width: 200px;
    flex: 1;
  }

  .mdc-switch {
    margin: 0 24px;
  }

  .mdc-switch--full-width {
    margin-left: auto;
  }
  .mdc-button--fullwidth {
    width: 100%;
  }
  #field {
    height: 100%;
  }

  .mdc-select__menu .mdc-list .mdc-list-item.mdc-list-item--selected or-icon {
    --or-icon-fill: var(--or-app-color4);
  }

  .mdc-menu__searchable {
    overflow: hidden;
  }
  .mdc-menu__searchable.mdc-menu-surface--open {
    display: flex;
    flex-direction: column-reverse;
  }
  .mdc-menu__searchable.mdc-menu-surface--is-open-below {
    flex-direction: column;
  }

  /* Prevent mouse events being fired from inside the or-icon shadowDOM */
  .mdc-list-item__graphic > or-icon {
    pointer-events: none;
  }
`,OrMwcInput=class extends o{constructor(){super(...arguments),this.readonly=!1,this.required=!1,this.checked=!1,this.indeterminate=!1,this.multiple=!1,this.searchLabel="search",this.compact=!1,this.comfortable=!1,this.raised=!1,this.action=!1,this.unElevated=!1,this.outlined=!1,this.rounded=!1,this.disableSliderNumberInput=!1,this.fullWidth=!1,this.helperPersistent=!1,this.autoValidate=!1,this.charCounter=!1,this.disabled=!1,this.continuous=!1,this.resizeVertical=!1,this.censored=!1,this.advertised=!1,this._selectedIndex=-1,this.isUiValid=!0}static get styles(){return[e`
        ${i(iconButtonStyle)}
      `,e`
        ${i(buttonStyle)}
      `,e`
        ${i(buttonFabStyle)}
      `,e`
        ${i(textfieldStyle)}
      `,e`
        ${i(rippleStyle)}
      `,e`
        ${i(lineRippleStyle)}
      `,e`
        ${i(floatingLabelStyle)}
      `,e`
        ${i(formFieldStyle)}
      `,e`
        ${i(checkboxStyle)}
      `,e`
        ${i(radioStyle)}
      `,e`
        ${i(switchStyle)}
      `,e`
        ${i(selectStyle)}
      `,e`
        ${i(listStyle)}
      `,e`
        ${i(menuStyle)}
      `,e`
        ${i(menuSurfaceStyle)}
      `,e`
        ${i(sliderStyle)}
      `,style]}get nativeValue(){if(this._mdcComponent)return this._mdcComponent.value}disconnectedCallback(){var e,t;super.disconnectedCallback(),this._mdcComponent&&(this._mdcComponent.destroy(),this._mdcComponent=void 0,null==(e=this._menuObserver)||e.disconnect()),this._mdcComponent2&&(this._mdcComponent2.destroy(),this._mdcComponent2=void 0,null==(t=this._menuObserver)||t.disconnect())}shouldUpdate(e){return e.has("indeterminate")&&this._mdcComponent&&this.type===InputType.CHECKBOX&&(this._mdcComponent.indeterminate=this.indeterminate),e.has("disabled")&&(this._mdcComponent&&(this._mdcComponent.disabled=this.disabled),this.type===InputType.RANGE&&this._mdcComponent2&&(this._mdcComponent2.disabled=this.disabled)),e.has("readonly")&&(this._mdcComponent&&(this._mdcComponent.readonly=this.readonly),this.type===InputType.RANGE&&this._mdcComponent2&&(this._mdcComponent2.readonly=this.readonly)),!this.type&&this.value&&(this.value instanceof Date?this.type=InputType.DATETIME:"boolean"==typeof this.value?this.type=InputType.CHECKBOX:"number"==typeof this.value?this.type=InputType.NUMBER:"string"==typeof this.value?this.type=InputType.TEXT:this.type=InputType.JSON),!0}focus(){this.type===InputType.RANGE&&this._mdcComponent2&&"function"==typeof this._mdcComponent2.focus?this._mdcComponent2.focus():this._mdcComponent&&"function"==typeof this._mdcComponent.focus&&this._mdcComponent.focus()}render(){if(this.type){let e=!this.fullWidth&&this.label,i=!this.fullWidth&&this.outlined,o=!!this.helperText,n=!this.isUiValid&&(!!this.errorMessage||!!this.validationMessage),s={"mdc-text-field-helper-text--persistent":!n&&this.helperPersistent,"mdc-text-field-helper-text--validation-msg":n},a=null!==this.value&&void 0!==this.value||!1===this.value,p=e?t`<span class="mdc-floating-label ${a?"mdc-floating-label--float-above":""}" id="label"
            >${this.label}</span
          >`:void 0;switch(this.type){case InputType.RADIO:let h=this.resolveOptions(this.options);return t`
            <div class="mdc-radio-container">
              ${h?h.map(([e,i])=>t` <div id="field" class="mdc-form-field">
                        <div class="mdc-radio">
                          <input
                            type="radio"
                            id="elem-${e}"
                            name="${d(this.name)}"
                            value="${e}"
                            .checked="${this.value===e}"
                            ?required="${this.required}"
                            ?disabled="${this.disabled||this.readonly}"
                            @change="${t=>this.onValueChange(t.target,e)}"
                            class="mdc-radio__native-control"
                          />
                          <div class="mdc-radio__background">
                            <div class="mdc-radio__outer-circle"></div>
                            <div class="mdc-radio__inner-circle"></div>
                          </div>
                          <div class="mdc-radio__ripple"></div>
                        </div>
                        <label for="elem-${e}"><or-translate value="${i}"></or-translate></label>
                      </div>`):""}
            </div>
          `;case InputType.SWITCH:let u={"mdc-switch--disabled":this.disabled||this.readonly,"mdc-switch--full-width":this.fullWidth,"mdc-switch--checked":this.value};return t`
            <span id="wrapper">
              ${this.label?t`<label for="elem" class="${this.disabled?"mdc-switch--disabled":""}">${this.label}</label>`:""}
              <div id="component" class="mdc-switch ${l(u)}">
                <div class="mdc-switch__track"></div>
                <div class="mdc-switch__thumb-underlay">
                  <div class="mdc-switch__thumb">
                    <input
                      type="checkbox"
                      id="elem"
                      class="mdc-switch__native-control"
                      ?checked="${this.value}"
                      ?required="${this.required}"
                      ?disabled="${this.disabled||this.readonly}"
                      @change="${e=>this.onValueChange(e.target,e.target.checked)}"
                      role="switch"
                    />
                  </div>
                </div>
              </div>
            </span>
          `;case InputType.LIST:let m={"mdc-select--outlined":i,"mdc-select--disabled":this.disabled,"mdc-select--required":this.required,"mdc-select--dense":!1,"mdc-select--no-label":!this.label,"mdc-select--with-leading-icon":!!this.icon},y=this.resolveOptions(this.options);return this._selectedIndex=-1,t`
            <div
              id="component"
              class="mdc-list mdc-select ${l(m)}"
              @MDCList:action="${e=>this.onValueChange(void 0,-1===e.detail.index?void 0:Array.isArray(this.options[e.detail.index])?this.options[e.detail.index][0]:this.options[e.detail.index])}"
            >
              <ul class="mdc-list">
                ${y?y.map(([e,i],o)=>(this.value===e&&(this._selectedIndex=o),t`<li
                          class="${l({"mdc-list-item":!0,"mdc-list-item--selected":this.value===e})}"
                          role="option"
                          data-value="${e}"
                        >
                          <or-translate value="${i}"></or-translate>
                        </li>`)):""}
              </ul>
            </div>
          `;case InputType.SELECT:let v,_={"mdc-select--outlined":i,"mdc-select--filled":!i,"mdc-select--disabled":this.disabled||this.readonly,"mdc-select--required":this.required,"mdc-select--dense":!1,"dense-comfortable":this.comfortable,"mdc-select--no-label":!this.label,"mdc-select--with-leading-icon":!!this.icon,"or-mwc-input--rounded":this.rounded};v=void 0!=this.searchProvider?this.searchProvider(this.searchableValue):this.resolveOptions(this.options);let b=(e,t)=>{var i;let o=t.value;if(this.multiple){e.stopPropagation();let t=null!=(i=this._tempValue)?i:Array.isArray(this.value)?[...this.value]:void 0!==this.value?[this.value]:[],n=t.findIndex(e=>e===o);n>=0?t.splice(n,1):t.push(o);let s=e.composedPath()[0].closest("li"),a=s.getElementsByTagName("or-icon")[0];s&&(n>=0?s.classList.remove("mdc-list-item--selected"):s.classList.add("mdc-list-item--selected")),a&&(a.icon=n>=0?"checkbox-blank-outline":"checkbox-marked"),this._tempValue=t}else void 0==this.searchProvider&&Array.isArray(v)||this.onValueChange(void 0,t.value)},f=()=>{var e;let t=null!=(e=this._tempValue)?e:this.value;if(window.setTimeout(()=>{this._mdcComponent&&this._mdcComponent.foundation.adapter.floatLabel(t&&(!Array.isArray(t)||t.length>0))}),!this._tempValue)return;let i=[...this._tempValue];this._tempValue=void 0,this.onValueChange(void 0,i)},T=e=>void 0==this.searchProvider||e&&0!=e.length?w(this.multiple?C.MULTI_TICK:C.SELECT,t`${null==e?void 0:e.map(([e,t],i)=>O({text:t,value:e},i,Array.isArray(this.value)?this.value:this.value?[this.value]:[],this.multiple?C.MULTI_TICK:C.SELECT,!1,b))}`,!1,void 0):t`<span class="mdc-text-field-helper-line" style="margin: 8px 8px 8px 0;"
                >${$.t("noResults")}</span
              >`;return t`
            <div
              id="component"
              class="mdc-select ${l(_)}"
              @MDCSelect:change="${e=>__awaiter(this,void 0,void 0,function*(){let t=Array.isArray(v)?v:yield v;this.onValueChange(void 0,-1===e.detail.index?void 0:Array.isArray(t[e.detail.index])?t[e.detail.index][0]:t[e.detail.index])})}"
            >
              <div
                class="mdc-select__anchor"
                role="button"
                aria-haspopup="listbox"
                aria-expanded="false"
                aria-disabled="${""+(this.disabled||this.readonly)}"
                aria-labelledby="label selected-text"
              >
                ${!i?t`<span class="mdc-select__ripple"></span>`:void 0}
                ${i?this.renderOutlined(p):p}
                <span class="mdc-select__selected-text-container">
                  <span id="selected-text" class="mdc-select__selected-text"></span>
                </span>
                <span class="mdc-select__dropdown-icon">
                  <svg class="mdc-select__dropdown-icon-graphic" viewBox="7 10 10 5">
                    <polygon
                      class="mdc-select__dropdown-icon-inactive"
                      stroke="none"
                      fill-rule="evenodd"
                      points="7 10 12 15 17 10"
                    ></polygon>
                    <polygon
                      class="mdc-select__dropdown-icon-active"
                      stroke="none"
                      fill-rule="evenodd"
                      points="7 15 12 10 17 15"
                    ></polygon>
                  </svg>
                </span>
                ${!i?t`<div class="mdc-line-ripple"></div>`:""}
              </div>
              <div
                id="mdc-select-menu"
                class="mdc-select__menu mdc-menu mdc-menu-surface mdc-menu-surface--fixed ${void 0!=this.searchProvider?"mdc-menu__searchable":void 0}"
                @MDCMenuSurface:closed="${f}"
              >
                ${r(void 0!=this.searchProvider,()=>t`
                    <label id="select-searchable" class="mdc-text-field mdc-text-field--filled">
                      <span
                        class="mdc-floating-label"
                        style="color: rgba(0, 0, 0, 0.6); text-transform: capitalize; visibility: ${this.searchableValue?"hidden":"visible"}"
                        id="my-label-id"
                      >
                        <or-translate .value="${this.searchLabel}"></or-translate>
                      </span>
                      <input
                        id="searchable-input"
                        class="mdc-text-field__input"
                        type="text"
                        @keyup="${e=>this.searchableValue=e.target.value}"
                      />
                    </label>
                  `)}
                ${r(Array.isArray(v),()=>T(v),()=>c(new Promise(e=>__awaiter(this,void 0,void 0,function*(){e(T((yield v)))})),t`<span class="mdc-text-field-helper-line" style="margin: 8px 8px 8px 0;"
                        >${$.t("loading")}</span
                      >`))}
              </div>
              ${o||n?t` <p
                      id="component-helper-text"
                      class="mdc-select-helper-text ${l(s)}"
                      aria-hidden="true"
                    >
                      ${n?this.errorMessage||this.validationMessage:this.helperText}
                    </p>`:""}
            </div>
          `;case InputType.BUTTON_TOGGLE:return t`
            <button
              id="component"
              class="mdc-icon-button ${this.value?"mdc-icon-button--on":""}"
              ?readonly="${this.readonly}"
              ?disabled="${this.disabled}"
              @MDCIconButtonToggle:change="${e=>this.onValueChange(void 0,e.detail.isOn)}"
            >
              ${this.icon?t`<or-icon class="mdc-icon-button__icon" aria-hidden="true" icon="${this.icon}"></or-icon>`:""}
              ${this.iconOn?t`<or-icon class="mdc-icon-button__icon mdc-icon-button__icon--on" aria-hidden="true" icon="${this.iconOn}"></or-icon>`:""}
            </button>
          `;case InputType.BUTTON:case InputType.BUTTON_MOMENTARY:{let e=e=>{this.disabled&&e.stopPropagation(),n&&this.dispatchEvent(new OrInputChangedEvent(!0,null))},i=e=>{this.disabled&&e.stopPropagation(),n&&this.dispatchEvent(new OrInputChangedEvent(!1,!0))},o=e=>{this.disabled&&e.stopPropagation(),n||this.dispatchEvent(new OrInputChangedEvent(!0,null))},n=this.type===InputType.BUTTON_MOMENTARY,s=!this.action&&!this.label;!s||this.iconTrailing||this.icon||(this.icon="circle");let a={"mdc-icon-button":s,"mdc-fab":!s&&this.action,"mdc-fab--extended":!s&&this.action&&!!this.label,"mdc-fab--mini":!s&&this.action&&(this.compact||this.comfortable),"mdc-button":!s&&!this.action,"mdc-button--raised":!s&&!this.action&&this.raised,"mdc-button--unelevated":!s&&!this.action&&this.unElevated,"mdc-button--outlined":!s&&!this.action&&(this.outlined||n),"mdc-button--rounded":!s&&!this.action&&this.rounded,"mdc-button--fullwidth":this.fullWidth};return t`
            <button
              id="component"
              class="${l(a)}"
              ?readonly="${this.readonly}"
              ?disabled="${this.disabled}"
              @click="${e=>o(e)}"
              @mousedown="${t=>e(t)}"
              @mouseup="${e=>i(e)}"
            >
              ${!s?t`<div class="mdc-button__ripple"></div>`:""}
              ${this.icon?t`<or-icon class="${s?"":this.action?"mdc-fab__icon":"mdc-button__icon"}" aria-hidden="true" icon="${this.icon}"></or-icon>`:""}
              ${this.label?t`<span class="${this.action?"mdc-fab__label":"mdc-button__label"}"><or-translate .value="${this.label}"></or-translate></span>`:""}
              ${!s&&this.iconTrailing?t`<or-icon class="${this.action?"mdc-fab__icon":"mdc-button__icon"}" aria-hidden="true" icon="${this.iconTrailing}"></or-icon>`:""}
            </button>
          `}case InputType.CHECKBOX_LIST:Array.isArray(this.value)||(null===this.value||void 0===this.value?this.value=[]:this.value=[this.value]);let I=this.resolveOptions(this.options);return this._selectedIndex=-1,t`
            <div class="mdc-checkbox-list">
              ${I?I.map(([e,i],o)=>(this.value===e&&(this._selectedIndex=o),t`
                        <div id="field" class="mdc-form-field">
                          <div id="component" class="mdc-checkbox">
                            <input
                              type="checkbox"
                              ?checked="${this.value&&this.value.includes(e)}"
                              ?required="${this.required}"
                              name="${e}"
                              ?disabled="${this.disabled||this.readonly}"
                              @change="${t=>{let i=this.value;t.target.checked?i.includes(e)||(i=[e,...i]):i=i.filter(t=>t!==e),this.onValueChange(t.target,i)}}"
                              class="mdc-checkbox__native-control"
                              id="elem-${e}"
                            />

                            <label for="elem-${e}"><or-translate value="${i}"></or-translate></label>
                          </div>
                        </div>
                      `)):""}
            </div>
          `;case InputType.CHECKBOX:let g={"mdc-checkbox":!0,"mdc-checkbox--disabled":this.disabled||this.readonly};return t`
            <div id="field" class="mdc-form-field">
              <div id="component" class="${l(g)}">
                <input
                  type="checkbox"
                  id="elem"
                  data-indeterminate="${this.indeterminate}"
                  ?checked="${this.value}"
                  ?required="${this.required}"
                  ?disabled="${this.disabled||this.readonly}"
                  @change="${e=>this.onValueChange(e.target,e.target.checked)}"
                  class="mdc-checkbox__native-control"
                />
                <div class="mdc-checkbox__background">
                  <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                    <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"></path>
                  </svg>
                  <div class="mdc-checkbox__mixedmark"></div>
                </div>
                <div class="mdc-checkbox__ripple"></div>
              </div>
              <label class="mdc-checkbox-circle" for="elem">${this.label}</label>
            </div>
          `;case InputType.COLOUR:return t`
            <div id="component" style="width: 100%; display: inline-flex; align-items: center; padding: 8px 0;">
              <input
                type="color"
                id="elem"
                style="border: none; height: 31px; width: 31px; padding: 1px 3px; min-height: 22px; min-width: 30px;cursor: pointer"
                value="${this.value}"
                ?disabled="${this.disabled||this.readonly}"
                ?required="${this.required}"
                @change="${e=>this.onValueChange(e.target,e.target.value)}"
              />
              <label style="margin-left: 10px; cursor: pointer" for="elem">${this.label}</label>
            </div>
          `;case InputType.NUMBER:case InputType.RANGE:case InputType.DATE:case InputType.DATETIME:case InputType.TIME:case InputType.MONTH:case InputType.WEEK:case InputType.EMAIL:case InputType.PASSWORD:case InputType.TELEPHONE:case InputType.URL:case InputType.TEXT:case InputType.TEXTAREA:case InputType.JSON:case InputType.JSON_OBJECT:{let e,r=[void 0===this.value||null===this.value?void 0:this.value,this.min,this.max];if(r.some(e=>"string"!=typeof e))if(this.type===InputType.JSON||this.type===InputType.JSON_OBJECT)if(void 0!==r[0]){if("string"!=typeof r[0]||null===r[0])try{r[0]=JSON.stringify(r[0],null,2)}catch(e){console.warn("Failed to parse JSON expression for input control"),r[0]=""}}else r[0]="";else{let e=this.format?Object.assign({},this.format):{};switch(this.type){case InputType.TIME:e.asDate=!0,e.hour12=!1,e.timeStyle=this.step&&this.step<60?"medium":"short";break;case InputType.DATE:e.asDate=!0,e.momentJsFormat="YYYY-MM-DD";break;case InputType.WEEK:e.asDate=!0,e.momentJsFormat="YYYY-[W]WW";break;case InputType.MONTH:e.asDate=!0,e.momentJsFormat="YYYY-MM";break;case InputType.DATETIME:e.asDate=!0,e.momentJsFormat="YYYY-MM-DDTHH:mm";break;case InputType.NUMBER:null!=e.maximumFractionDigits||(e.maximumFractionDigits=20)}e.useGrouping=!1,r=r.map(t=>void 0!==t?x.getValueAsString(t,()=>e,"en-GB"):void 0)}let c=this.label,h=this.type,u="component";if(this.type===InputType.RANGE&&(c=void 0,i=!1,o=!1,h=InputType.NUMBER,u="number"),!(this.type===InputType.RANGE&&this.disableSliderNumberInput)){this.censored&&(h=InputType.PASSWORD),this.type===InputType.PASSWORD&&this.advertised&&(h=InputType.TEXT);let m={"mdc-text-field":!0,"mdc-text-field--invalid":!this.valid,"mdc-text-field--filled":!i,"mdc-text-field--outlined":i,"mdc-text-field--textarea":h===InputType.TEXTAREA||h===InputType.JSON||h===InputType.JSON_OBJECT,"mdc-text-field--disabled":this.disabled,"mdc-text-field--fullwidth":this.fullWidth&&!i,"dense-comfortable":this.comfortable&&h!==InputType.TEXTAREA&&h!==InputType.JSON&&h!==InputType.JSON_OBJECT,"dense-compact":!this.comfortable&&this.compact,"mdc-text-field--label-floating":a,"mdc-text-field--no-label":!this.label,"mdc-text-field--with-leading-icon":!!this.icon,"mdc-text-field--with-trailing-icon":!!this.iconTrailing,"or-mwc-input--rounded":this.rounded};e=h===InputType.TEXTAREA||h===InputType.JSON||h===InputType.JSON_OBJECT?t` <textarea
                    id="elem"
                    class="mdc-text-field__input ${this.resizeVertical?"resize-vertical":""}"
                    ?required="${this.required}"
                    ?readonly="${this.readonly}"
                    ?disabled="${this.disabled}"
                    minlength="${d(this.minLength)}"
                    maxlength="${d(this.maxLength)}"
                    rows="${this.rows?this.rows:5}"
                    cols="${d(this.cols)}"
                    aria-label="${d(c)}"
                    aria-labelledby="${d(c?"label":void 0)}"
                    @change="${e=>this.onValueChange(e.target,e.target.value)}"
                  >
${r[0]?r[0]:""}</textarea>`:t` <input
                    type="${h}"
                    id="elem"
                    aria-labelledby="${d(c?"label":void 0)}"
                    class="mdc-text-field__input"
                    ?required="${this.required}"
                    ?readonly="${this.readonly}"
                    ?disabled="${this.disabled}"
                    min="${d(r[1])}"
                    max="${d(r[2])}"
                    step="${this.step?this.step:"any"}"
                    minlength="${d(this.minLength)}"
                    pattern="${d(this.pattern)}"
                    maxlength="${d(this.maxLength)}"
                    placeholder="${d(this.placeHolder)}"
                    .value="${null!==r[0]&&void 0!==r[0]?r[0]:""}"
                    @keydown="${e=>{("Enter"===e.code||"NumpadEnter"===e.code)&&this.onValueChange(e.target,e.target.value,!0)}}"
                    @blur="${e=>{""===e.target.value&&this.reportValidity()}}"
                    @change="${e=>this.onValueChange(e.target,e.target.value)}"
                  />`,e=t`
              <label id="${u}" class="${l(m)}">
                ${this.icon?t`<or-icon class="mdc-text-field__icon mdc-text-field__icon--leading" style="color: ${this.iconColor?"#"+this.iconColor:"unset"}" aria-hidden="true" icon="${this.icon}"></or-icon>`:""}
                ${i?"":t`<span class="mdc-text-field__ripple"></span>`} ${e}
                ${i?this.renderOutlined(p):p}
                ${i?"":t`<span class="mdc-line-ripple"></span>`}
                ${this.type===InputType.PASSWORD&&!this.censored?t`<or-icon class="mdc-text-field__icon mdc-text-field__icon--trailing" aria-hidden="true" icon=${this.advertised?"eye":"eye-off"} style="pointer-events: auto;" @click=${()=>this.advertised=!this.advertised}></or-icon>`:""}
                ${this.iconTrailing?t`<or-icon class="mdc-text-field__icon mdc-text-field__icon--trailing" aria-hidden="true" icon="${this.iconTrailing}"></or-icon>`:""}
              </label>
              ${o||n?t`
                      <div class="mdc-text-field-helper-line">
                        <div class="mdc-text-field-helper-text ${l(s)}">
                          ${n?this.errorMessage||this.validationMessage:this.helperText}
                        </div>
                        ${this.charCounter&&!this.readonly?t`<div class="mdc-text-field-character-counter"></div>`:""}
                      </div>
                    `:""}
            `}if(this.type===InputType.RANGE){let i={"mdc-slider":!0,"mdc-slider--range":this.continuous,"mdc-slider--discreet":!this.continuous,"mdc-slider--disabled":this.disabled||this.readonly};e=t`
              <span id="wrapper">
                ${this.label?t`<label for="component" class="${this.disabled?"mdc-switch--disabled":""}">${this.label}</label>`:""}
                <div
                  id="component"
                  class="${l(i)}"
                  @MDCSlider:change="${e=>this.onValueChange(void 0,e.detail.value)}"
                >
                  <input
                    id="elem"
                    class="mdc-slider__input"
                    type="range"
                    min="${d(r[1])}"
                    max="${d(r[2])}"
                    value="${r[0]||r[1]||0}"
                    name="slider"
                    step="${this.step||1}"
                    ?readonly="${this.readonly}"
                    ?disabled="${this.disabled}"
                    aria-label="${d(this.label)}"
                  />
                  <div class="mdc-slider__track">
                    <div class="mdc-slider__track--inactive"></div>
                    <div class="mdc-slider__track--active">
                      <div class="mdc-slider__track--active_fill"></div>
                    </div>
                  </div>
                  <div class="mdc-slider__thumb">
                    ${!this.continuous?t`<div class="mdc-slider__value-indicator-container" aria-hidden="true">
                            <div class="mdc-slider__value-indicator">
                              <span class="mdc-slider__value-indicator-text"> 50 </span>
                            </div>
                          </div>`:""}
                    <div class="mdc-slider__thumb-knob"></div>
                  </div>
                </div>
                ${e?t`<div style="min-width: 70px; width: 70px;">${e}</div>`:""}
              </span>
            `}return e}}}return t`<span>INPUT TYPE NOT IMPLEMENTED</span>`}_getFormat(){if(this.format)return this.format}update(e){if(e.has("autoValidate")&&this._mdcComponent){let e=this._mdcComponent;e.foundation&&e.foundation.setValidateOnValueChange&&e.foundation.setValidateOnValueChange(this.autoValidate)}super.update(e)}firstUpdated(e){super.firstUpdated(e),this.autoValidate&&this.reportValidity()}updated(e){var t,i;if(super.updated(e),e.has("type")){let e=this.shadowRoot.getElementById("component");if(this._mdcComponent&&(this._mdcComponent.destroy(),this._mdcComponent=void 0),this._mdcComponent2&&(this._mdcComponent2.destroy(),this._mdcComponent2=void 0),e&&this.type){switch(this.type){case InputType.LIST:let t=new _(e);this._mdcComponent=t,t.selectedIndex=this._selectedIndex;break;case InputType.SELECT:let i=new v(e);this._mdcComponent=i,(null===this.value||void 0===this.value)&&(i.selectedIndex=-1),this.multiple&&(this._mdcComponent.foundation.adapter.getSelectedIndex=()=>{if(!Array.isArray(this.value)||0===this.value.length)return -1;let e=this.value[0];return this._mdcComponent.foundation.adapter.getMenuItemValues().indexOf(e)}),i.useDefaultValidation=!this.multiple,i.valid=!this.required||!this.multiple&&i.valid||this.multiple&&Array.isArray(this.value)&&this.value.length>0;let o=this.getSelectedTextValue();this._mdcComponent.foundation.adapter.setSelectedText(o),this._mdcComponent.foundation.adapter.floatLabel(!!o),this._menuObserver||(this._menuObserver=new IntersectionObserver((e,t)=>{var i,o;e[0].target.style.minWidth!=(null==(i=e[0].target.parentElement)?void 0:i.clientWidth)+"px"&&(e[0].target.style.minWidth=(null==(o=e[0].target.parentElement)?void 0:o.clientWidth)+"px")}),this._menuObserver.observe(this.shadowRoot.getElementById("mdc-select-menu")));let n=void 0!==this.searchProvider,s=this.multiple;i.menu.menuSurface_.foundation.handleBodyClick=function(e){let t=e.composedPath()[0];if(this.adapter.isElementInContainer(t)){if(!n)return;else if(t instanceof Element&&!t.className.includes("mdc-list-item"))return;else if(s)return}i.menu.menuSurface_.close()};break;case InputType.RADIO:case InputType.CHECKBOX_LIST:case InputType.COLOUR:break;case InputType.BUTTON:case InputType.BUTTON_MOMENTARY:let a=!this.action&&!this.label,l=new h(e);a&&(l.unbounded=!0),this._mdcComponent=l;break;case InputType.BUTTON_TOGGLE:this._mdcComponent=new f(e);break;case InputType.CHECKBOX:this._mdcComponent=new u(e);let d=this.shadowRoot.getElementById("field");if(d){let e=new b(d);e.input=this._mdcComponent,this._mdcComponent2=e}break;case InputType.SWITCH:this._mdcComponent=new m(e);break;case InputType.RANGE:this._mdcComponent=new y(e);let r=this.shadowRoot.getElementById("number");if(r){let e=new p(r);e.useNativeValidation=!1,this._mdcComponent2=e}break;default:let c=new p(e);c.useNativeValidation=!1,this._mdcComponent=c}this._mdcComponent&&this.focused&&"function"==typeof this._mdcComponent.focus&&this._mdcComponent.focus()}}else{if(this.type===InputType.SELECT&&this._mdcComponent){e.has("options")&&this._mdcComponent.layoutOptions(),this._mdcComponent.disabled=!!(this.disabled||this.readonly),this._mdcComponent.useDefaultValidation=!this.multiple,this._mdcComponent.valid=!this.required||!this.multiple&&this._mdcComponent.valid||this.multiple&&Array.isArray(this.value)&&this.value.length>0;let t=this.getSelectedTextValue();this._mdcComponent.foundation.adapter.setSelectedText(t),this._mdcComponent.foundation.adapter.floatLabel(!!t)}else if(this.type===InputType.RANGE&&this._mdcComponent){let e=this._mdcComponent;e.setDisabled(this.disabled||this.readonly),e.setValue(this.value)}else if(this.type===InputType.SWITCH&&this._mdcComponent)this._mdcComponent.checked=this.value;else if(this.type===InputType.CHECKBOX&&this._mdcComponent){let e=this._mdcComponent;e.checked=!!this.value,e.disabled=!!(this.disabled||this.readonly)}this._mdcComponent&&(this._mdcComponent.required=!!this.required)}e.has("label")&&(null==(i=null==(t=this._mdcComponent)?void 0:t.layout)||i.call(t)),this.autoValidate&&this.reportValidity()}renderOutlined(e){return t`
      <span class="mdc-notched-outline">
        <span class="mdc-notched-outline__leading"></span>
        ${e?t` <span class="mdc-notched-outline__notch"> ${e} </span> `:""}
        <span class="mdc-notched-outline__trailing"></span>
      </span>
    `}setCustomValidity(e){this.errorMessage=e;let t=this.shadowRoot.getElementById("elem");t&&t.setCustomValidity&&t.setCustomValidity(null!=e?e:""),this.reportValidity()}checkValidity(){let e=this.shadowRoot.getElementById("elem"),t=!0;return e&&e.validity&&(t=e.validity.valid),t&&(this.type===InputType.JSON||this.type===InputType.JSON_OBJECT)&&void 0!==this.value&&null!==this.value&&""===this._mdcComponent.value&&(t=!1),t}reportValidity(){let e=this.checkValidity();return this.isUiValid=e,this._mdcComponent&&(this._mdcComponent.valid=e),e}onValueChange(e,t,i){var o,n;let s,a=this.value;if("undefined"===t&&(a=null,t=void 0),"null"===t&&(a=void 0,t=null),"string"==typeof t)switch(this.type){case InputType.CHECKBOX:case InputType.SWITCH:t="on"===t;break;case InputType.JSON:case InputType.JSON_OBJECT:case InputType.NUMBER:case InputType.RANGE:if(""===t)t=null;else try{t=JSON.parse(t),this.type===InputType.JSON_OBJECT&&("object"!=typeof t||Array.isArray(t))&&(t=this.value,s=$.t("validation.invalidJSON"))}catch(e){t=this.value,s=this.type===InputType.JSON||this.type==InputType.JSON_OBJECT?$.t("validation.invalidJSON"):$.t("validation.invalidNumber")}break;case InputType.DATETIME:if(""===t)t=null;else try{t=Date.parse(t)}catch(e){t=this.value,s=$.t("validation.invalidDate")}}if(this.value=t,this.setCustomValidity(s),this.reportValidity(),this.type!==InputType.CHECKBOX_LIST&&t!==a&&(this.type===InputType.RANGE&&(this._mdcComponent.setValue(t),this._mdcComponent2&&(this._mdcComponent2.value=t)),this.dispatchEvent(new OrInputChangedEvent(this.value,a,i))),void 0!=this.searchProvider&&this.type===InputType.SELECT){let e=null==(n=null==(o=this.shadowRoot)?void 0:o.getElementById("select-searchable"))?void 0:n.children[1];e&&(this.searchableValue=void 0,e.value="")}this.type!==InputType.CHECKBOX_LIST||x.objectsEqual(t,a,!0)||this.dispatchEvent(new OrInputChangedEvent(t,a,i))}get valid(){let e=this.shadowRoot.getElementById("elem");return!e||!e.checkValidity||e.checkValidity()}get currentValue(){let e=this.shadowRoot.getElementById("elem");if(e&&e.value)return e.value}resolveOptions(e){let t;return e&&e.length>0&&(t=e.map(e=>{if(Array.isArray(e))return e;{let t=""+e;return[e,$.t(t,{defaultValue:x.camelCaseToSentenceCase(t)})]}})),t}getSelectedTextValue(e){let t=this.value,i=Array.isArray(t)?t:null!=t?[t]:void 0;if(!i)return"";let o=e||this.resolveOptions(this.options);return o&&i?i.map(e=>o.find(([t,i],o)=>e===t)).map(e=>e?e[1]:"").join(", "):""}};__decorate([s({type:Boolean})],OrMwcInput.prototype,"focused",void 0),__decorate([s()],OrMwcInput.prototype,"value",void 0),__decorate([s({type:String})],OrMwcInput.prototype,"type",void 0),__decorate([s({type:String})],OrMwcInput.prototype,"name",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"readonly",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"required",void 0),__decorate([s()],OrMwcInput.prototype,"max",void 0),__decorate([s()],OrMwcInput.prototype,"min",void 0),__decorate([s({type:Number})],OrMwcInput.prototype,"step",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"checked",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"indeterminate",void 0),__decorate([s({type:Number})],OrMwcInput.prototype,"maxLength",void 0),__decorate([s({type:Number})],OrMwcInput.prototype,"minLength",void 0),__decorate([s({type:Number})],OrMwcInput.prototype,"rows",void 0),__decorate([s({type:Number})],OrMwcInput.prototype,"cols",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"multiple",void 0),__decorate([s({type:String,attribute:!0,reflect:!1})],OrMwcInput.prototype,"pattern",void 0),__decorate([s({type:String})],OrMwcInput.prototype,"placeHolder",void 0),__decorate([s({type:Array})],OrMwcInput.prototype,"options",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"autoSelect",void 0),__decorate([s({type:Object})],OrMwcInput.prototype,"searchProvider",void 0),__decorate([s({type:String})],OrMwcInput.prototype,"searchLabel",void 0),__decorate([s({type:String})],OrMwcInput.prototype,"icon",void 0),__decorate([s({type:String})],OrMwcInput.prototype,"iconColor",void 0),__decorate([s({type:String})],OrMwcInput.prototype,"iconOn",void 0),__decorate([s({type:String})],OrMwcInput.prototype,"iconTrailing",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"compact",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"comfortable",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"raised",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"action",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"unElevated",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"outlined",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"rounded",void 0),__decorate([s({type:Object})],OrMwcInput.prototype,"format",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"disableSliderNumberInput",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"fullWidth",void 0),__decorate([s({type:String})],OrMwcInput.prototype,"helperText",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"helperPersistent",void 0),__decorate([s({type:String,attribute:!0})],OrMwcInput.prototype,"validationMessage",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"autoValidate",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"charCounter",void 0),__decorate([s({type:String})],OrMwcInput.prototype,"label",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"disabled",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"continuous",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"resizeVertical",void 0),__decorate([s({type:Boolean})],OrMwcInput.prototype,"censored",void 0),__decorate([s({type:Boolean,reflect:!0})],OrMwcInput.prototype,"advertised",void 0),__decorate([a()],OrMwcInput.prototype,"isUiValid",void 0),__decorate([a()],OrMwcInput.prototype,"searchableValue",void 0),__decorate([a()],OrMwcInput.prototype,"errorMessage",void 0),OrMwcInput=__decorate([n("or-mwc-input")],OrMwcInput);export{OrMwcInput};